import React from 'react';
import styled from 'styled-components';
import FormEkyc from '../../../app/common/components/FormEkyc';
import {
    getChallengeData,
    clearChallengeInput,
    isChallengerSumbitBlocked,
} from '../../../utils/challengerMain';
import { IEkycServiceRequest } from './ekycServiceRequest';
import { ValidatorRule } from '../../../app/common/validator/validatorRule.constants';
import { IChallengeData } from '../../../utils/challengerMain';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { Spacer } from '../IdentityVerificationStyled';

const Description = styled.div`
     {
        margin-top: 24px;
        font-weight: 400;
        font-size: 16px;
        color: #686868;
    }
`;

const FormattedMessage = styled.span``;

export interface IEkycServiceFormStateProps {
    challengerPid: string;
    clientId: string;
    isSubmitting: boolean;
    EkycServiceValidatorRules?: ValidatorRule[];
    challengerDegenerate?: boolean;
}

export interface IEkycServiceFormDispatchProps {
    unlinkEkycService: (values: IEkycServiceRequest) => void;
    onCloseFunction: () => void;
}

export type EkycServiceFormProps = IEkycServiceFormStateProps & IEkycServiceFormDispatchProps;

export class EkycServiceForm extends React.Component<EkycServiceFormProps> {
    isChallengeLoaded: boolean;

    constructor(props: EkycServiceFormProps) {
        super(props);
        const { challengerPid } = this.props;
        this.isChallengeLoaded = !challengerPid;
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        const { isSubmitting, challengerPid, clientId, onCloseFunction } = this.props;

        return (
            <>
                <Description>
                    <FormattedMessage>
                        {TranslationHelpers.getFormattedMessage(
                            `ekyc.popup.description1.${clientId}`,
                        )}
                    </FormattedMessage>
                    <Spacer />
                    <FormattedMessage>
                        {TranslationHelpers.getFormattedMessage(
                            `ekyc.popup.description2.${clientId}`,
                        )}
                    </FormattedMessage>
                    <Spacer />
                    <FormattedMessage>
                        {TranslationHelpers.getFormattedMessage(
                            `ekyc.popup.description3.${clientId}`,
                        )}
                    </FormattedMessage>
                </Description>
                <FormEkyc
                    value={{}}
                    handleSubmit={this.handleSubmit}
                    loading={isSubmitting}
                    onCloseFunction={onCloseFunction}
                    saveButtonProps={{
                        qaId: 'qaId-ekyc',
                    }}
                    challengerPid={challengerPid}
                    challengerReadyCallback={(isChallengeLoaded: boolean) => {
                        this.isChallengeLoaded = isChallengeLoaded;
                    }}
                />
            </>
        );
    }

    private async handleSubmit() {
        const { clientId, unlinkEkycService, challengerPid } = this.props;
        try {
            const isSubmitBlocked: boolean = isChallengerSumbitBlocked(challengerPid);
            const challengeData: IChallengeData | undefined = getChallengeData(challengerPid);

            if (isSubmitBlocked || !challengeData) {
                return;
            }
            const requestData: IEkycServiceRequest = {
                clientId,
                challengeData,
            };

            await unlinkEkycService(requestData);

            clearChallengeInput();
        } catch (error) {}
    }
}
